<template>
  <splash></splash>
  <div class="container mt-4" dir="rtl">
    <sidebar></sidebar>
    <!-- Jobs -->
    <div class="card-panel-main col-lg-9 mb-5" style="transform: translateX(-19vw)">
      <div class="row">
        <div class="col-lg-12">
          <div class="card card-body card-panel-box border-0">
            <div class="d-flex justify-content-between">
              <h2 style="font-size: 1.2vw !important; text-align: right">ارزیابی ذی نفعان قدرت منفعت</h2>
              <div class="d-flex flex-column-reverse justify-content-start align-items-end">
                <div class="d-flex changer mx-2 mb-2">
                  <a class="bg-info" style="color: #000; font-size: 1vw; text-decoration: none">
                    نمودار
                  </a>
                  <router-link class="text-dark text-decoration-none" :to="`/beneficiary/order_by/power_for_management`">
                    جدول
                  </router-link>
                </div>
                <br>
                <button class="btn btn-primary btn-submit-1" @click="$router.go(-1)">برگشت</button>
              </div>
            </div>
            <hr class="mb-3">
            <center v-if="!status">
              {{ error }}
            </center>
            <center>
              <div v-if="status" class="" style="height: 27vw;">
                <apexchart
                    style="width: 50vw;"
                    type="scatter"
                    :options="chartOptions"
                    :series="series"
                ></apexchart>
                <hr>
                <div v-if="status" class="legend-container">
                  <ul class="legend-list">
                    <li v-for="(item, index) in legendData" :key="index" class="legend-item">
                      <span :style="{ backgroundColor: item.color }" class="legend-color"></span>
                      <span class="legend-text">{{ item.name }}</span>
                    </li>
                  </ul>
                </div>
              </div>
            </center>
            <br v-for="(item, index) in legendData">
            <br>
            <br>

            <br>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import Splash from "@/components/Splash/Splash";
import Sidebar from "@/components/Sidebar/Sidebar";
import { useToast } from "vue-toastification";

const toast = useToast();

export default {
  name: "beneficiary_id_order_by",
  components: { Sidebar, Splash, },
  data() {
    return {
      status: false,
      error: 'دوره ای برای ارزیابی ذی نفعان تعریف نشده است.',
      all_beneficiary: [],
      legendData: [],
      chartOptions: {

        chart: {
          height: 350,
          type: 'bubble'
        },
        dataLabels: {
          enabled: false
        },
        xaxis: {
          title: {
            text: 'قدرت',
            style: {
              fontFamily: 'Shabnam'
            }
          },

        },
        yaxis: {
          title: {
            text: 'علاقه',
            style: {
              fontFamily: 'Shabnam'
            }
          },

        },
        legend: {
          position: 'bottom',
          horizontalAlign: 'right',
          markers: {
            fillColors: ['#FF5733', '#33FF57', '#5733FF'] // رنگهای متفاوت برای راهنما
          }
        }
      },

      series: []
    };
  },
  methods: {
    all() {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      const formdata = new FormData();
      formdata.append('name', this.name);
      formdata.append('start_date', this.start_date);
      formdata.append('end_date', this.end_date);
      formdata.append('status', '0');

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/BeneficiaryPeriod/show`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.status = false;
              this.error = response.error;
              toast.error(response.error);
              return;
            }
            if (response.item) {
              this.status = true;
              this.all_beneficiaryMethod();
            }
          })
          .catch();
    },
    all_beneficiaryMethod() {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", `Bearer ${this.$cookies.get('token')}`);

      const formdata = new FormData();
      formdata.append('name', this.name);
      formdata.append('start_date', this.start_date);
      formdata.append('end_date', this.end_date);
      formdata.append('status', '0');

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: formdata,
        redirect: 'follow'
      };

      fetch(`${this.base_url}/beneficiary/all_for_power_aggregated`, requestOptions)
          .then(response => response.json())
          .then(response => {
            if (response.error) {
              this.error = response.error;
              toast.error(response.error);
              return;
            }
            this.all_beneficiary = [...response.all];
            this.updateChartSeries();
          })
          .catch();
    },
    updateChartSeries() {
      this.series = [{
        name: 'ذی نفعان',
        data: this.all_beneficiary.map((item, index) => ({
          x: item.total_power,
          y: item.total_interest,
          name: item.title,
          fillColor: ['#FF5733', '#33FF57', '#5733FF'][index % 3]// رنگهای متفاوت برای هر مورد
        }))
      }];
      this.updateLegendData()
    },
    updateLegendData() {
      // ساخت داده‌های راهنما به صورت دینامیک با توجه به داده‌های موجود در آرایه series
      this.legendData = this.series[0].data.map((item, index) => ({
        name: item.name,
        color: ['#FF5733', '#33FF57', '#5733FF'][index % 3]
      }));
    },


  },
  mounted() {
    this.all();
  }
};
</script>

<style scoped>
.row {
  padding: .5vw;
}
h3 {
  font-size: 1.5vw !important;
}
.sticky-header {
  position: sticky;
  top: 0;
  background-color: #fff;
  z-index: 2;
}
.changer {
  background-color: #AFAFAF;
  height: 2vw;
  border-radius: 1vw;
  width: 10vw;
  justify-content: space-evenly;
  &>a:nth-child(1) {
    width: 6vw;
    height: 2vw;
    background-color: #3742FA !important;
    color: #fff !important;
    transform: translateX(.7vw);
    border-radius: 1vw;
  }
  &>a {
    margin-right: -.5vw;
  }
  &>p:nth-child(2) {
    margin-left: 1vw;
  }
  &>p {
    cursor: pointer;
    font-size: 1vw;
  }
}
p {
  font-size: 1vw;
}
a {
  font-size: 1vw;
}
/* استایل‌های راهنما */
.legend-container {
  margin-top: 2vw;
}

.legend-list {
  list-style: none;
  padding: 0;
}

.legend-item {
  display: inline-block;
  margin-right: 1vw;
}

.legend-color {
  display: inline-block;
  width: 1vw;
  height: 1vw;
  border-radius: 50%;
  margin-right: 0.3vw;
}

.legend-text {
  font-size: 1vw;
  margin-right: 0.3vw;
}
</style>
